import { HTMLAttributes } from 'react';
import { useTranslate } from '@tolgee/react';
import styled from '@emotion/styled';
import { Button, message } from 'antd';
import useConfig from './hooks/useConfig';
import InsiteForm from './components/InsiteForm';

export const Container = styled.div`
  padding: 16px;
  background: #fff;
  > footer {
    display: flex;
    align-items: center;
    position: sticky;
    bottom: -16px;
    height: 56px;
    margin: -16px;
    margin-top: 16px;
    padding: 0 24px;
    background: #fff;
    box-shadow: 0px -2px 8px 0px rgba(167, 178, 204, 0.1),
      inset 0px 1px 0px 0px rgba(240, 242, 245, 1);
  }
`;

const getInsiteConfig = (config: Remind.Config): Remind.InsiteConfig => {
  const {
    taskId,
    inSiteRemindEnable,
    autoCloseEnable,
    aiGroup,
    userTagGroup,
    orderAbandonGroup,
    reviewGroup,
    taxGroup,
  } = config;

  return {
    taskId,
    inSiteRemindEnable,
    autoCloseEnable,
    aiGroup,
    userTagGroup,
    orderAbandonGroup,
    reviewGroup,
    taxGroup,
  };
};

export interface InsiteConfigProps extends HTMLAttributes<HTMLDivElement> {
  config: Remind.Config;
  onUpdateInsiteEnable: ReturnType<typeof useConfig>['updateInsiteEnable'];
  onUpdateInsiteScene: ReturnType<typeof useConfig>['updateInsiteScene'];
  aiOnly?: boolean;
}

function InsiteConfig(props: InsiteConfigProps) {
  const { config, onUpdateInsiteEnable, onUpdateInsiteScene, aiOnly, ...otherProps } = props;

  const { inSiteRemindEnable, ...initialValues } = getInsiteConfig(config);

  const { t } = useTranslate();

  return (
    <InsiteForm
      applyScope={config.applyScope}
      aiOnly={aiOnly}
      initialValues={initialValues}
      onSubmit={(values, helpers) => {
        return onUpdateInsiteScene(values)
          .then(() => {
            message.success(t('operation.saveSucceed'));

            helpers.resetForm();
          })
          .catch(() => {
            message.error(t('remind.网络错误，请稍后再试'));
          });
      }}
    >
      {(form, formProps) => {
        const { dirty, isSubmitting, handleSubmit } = formProps;

        return (
          <Container {...otherProps}>
            {form}
            <footer>
              <Button
                type="primary"
                disabled={!dirty}
                loading={isSubmitting}
                onClick={() => handleSubmit()}
              >
                {t('remind.保存')}
              </Button>
            </footer>
          </Container>
        );
      }}
    </InsiteForm>
  );
}

export default InsiteConfig;
